// extracted by mini-css-extract-plugin
export default {"p_tye":"_1f70340af5","slcted":"c29ccabbd7","slc_color":"_877a58ca2f","item_p":"d32f69fa33","r0":"d5c59d34fb"};